import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'failure-analysis';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CHANGE_PAGINATION = `${NAMESPACE}/CHANGE_PAGINATION`;

export const GET_FAILURE_TESTS = createApiNamespacedConstants('GET_FAILURE_TESTS');
export const GET_FAILURE_CAUSES = createApiNamespacedConstants('GET_FAILURE_CAUSES');
